import { contactInfo, districts } from '../../data/content';
import './ContactPage.css';

function ContactPage() {
  const benefits = [
    { icon: '🌽', title: 'Nutrient-Rich', desc: 'Packed with vitamins B & C, potassium, and magnesium for overall health and well-being.' },
    { icon: '🌿', title: 'High in Fiber', desc: 'Excellent source of dietary fiber promoting healthy digestion and a balanced gut.' },
    { icon: '⚡', title: 'Energy Booster', desc: 'Natural carbohydrates provide long-lasting energy — perfect for active lifestyles.' },
    { icon: '🛡️', title: 'Antioxidant Rich', desc: 'Lutein and zeaxanthin support eye health and protect against oxidative stress.' },
    { icon: '✅', title: 'Gluten-Free', desc: 'Naturally gluten-free — ideal for those with gluten intolerance or coeliac disease.' },
    { icon: '🚚', title: 'Cash on Delivery', desc: 'COD available across Western Province, Gampaha, Negombo, Kalutara, Panadura & Badulla.' },
  ];

  const deliveryZones = districts;

  return (
    <div className="contact-page-wrapper">

      {/* ══ HERO ══ */}
      <section className="contact-hero">
        <span className="contact-hero-kicker">Reach Out to Us</span>
        <h1>Let's Talk <em>Fresh</em> Corn</h1>
        <p className="contact-hero-desc">
          For domestic orders, HoReCa bulk supply, and export enquiries — our team is always open.
          නැවුම් ලෙස 100% දේශියව සකසන කරන ලද Corn Bliss Ready to Eat Sweetcorn.
        </p>
        <div className="contact-hero-pills">
          <a className="hero-pill hero-pill-green" href={`https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '')}`} target="_blank" rel="noopener noreferrer">
            💬 WhatsApp Order
          </a>
          <a className="hero-pill hero-pill-gold" href={`tel:${contactInfo.phones[0]}`}>
            📞 Call Now
          </a>
          <a className="hero-pill" href={`mailto:${contactInfo.email}`}>
            ✉️ Email Us
          </a>
        </div>
      </section>

      {/* ══ MAIN GRID ══ */}
      <div className="contact-main">

        {/* LEFT — Contact Cards */}
        <div className="contact-cards-col">
          <span className="contact-section-label">How to Reach Us</span>
          <h2 className="contact-section-title">Contact Details</h2>

          <div className="contact-cards-grid">

            {/* Phones */}
            {contactInfo.phones.map((phone, i) => (
              <div className="contact-card" key={i}>
                <div className="contact-card-icon">📞</div>
                <div className="contact-card-label">Phone {i + 1}</div>
                <div className="contact-card-value">
                  <a href={`tel:${phone}`}>{phone}</a>
                </div>
              </div>
            ))}

            {/* WhatsApp */}
            <div className="contact-card">
              <div className="contact-card-icon">💬</div>
              <div className="contact-card-label">WhatsApp</div>
              <div className="contact-card-value">
                <a href={`https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '')}`} target="_blank" rel="noopener noreferrer">
                  {contactInfo.whatsapp}
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="contact-card">
              <div className="contact-card-icon">✉️</div>
              <div className="contact-card-label">Email</div>
              <div className="contact-card-value">
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </div>
            </div>

            {/* Delivery Zones */}
            <div className="contact-card wide">
              <div className="contact-card-icon">🚚</div>
              <div className="contact-card-label">Delivery Zones — COD Available</div>
              <div className="delivery-zones">
                {deliveryZones.map((z) => (
                  <span className="zone-tag" key={z}>{z}</span>
                ))}
              </div>
            </div>

            {/* Social */}
            <div className="contact-card wide">
              <div className="contact-card-icon">📲</div>
              <div className="contact-card-label">Follow Us</div>
              <div className="contact-social-row">
                <a className="contact-social-btn" href={contactInfo.social.facebook} target="_blank" rel="noopener noreferrer">
                  📘 Facebook
                </a>
                <a className="contact-social-btn" href={`https://${contactInfo.social.tiktok}`} target="_blank" rel="noopener noreferrer">
                  🎵 TikTok
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* RIGHT — Pricing + Links */}
        <div className="contact-right-col">

          {/* Pricing Card */}
          <div className="pricing-card">
            <div className="pricing-card-top">
              <span className="pricing-card-label">Current Offer Prices</span>
              <h3>Ready-to-Eat Sweet Corn 🌽</h3>
            </div>

            <div className="pricing-card-body">
              <ul className="price-list">
                <li>
                  <span>1 kg Pack</span>
                  <span className="price-amount">Rs. 1,300</span>
                </li>
                <li>
                  <span>500 g Pack</span>
                  <span className="price-amount">Rs. 700</span>
                </li>
                <li>
                  <span>200 g Pack</span>
                  <span className="price-amount">Rs. 400</span>
                </li>
                <li className="combo-item">
                  <span>
                    <span className="combo-badge">Combo</span>&nbsp;
                    Small Pack — 3 flavors + cups (serves 4)
                  </span>
                  <span className="price-amount">Rs. 1,500</span>
                </li>
                <li className="combo-item">
                  <span>
                    <span className="combo-badge">Combo</span>&nbsp;
                    Medium Pack — 3 flavors + cups (serves 7)
                  </span>
                  <span className="price-amount">Rs. 2,500</span>
                </li>
              </ul>

              <div className="pricing-cod-note">
                🚚 Free delivery on combo packs · Cash on Delivery available
              </div>
            </div>
          </div>

          {/* Quick Links */}
          {/* <div className="links-card">
            <h3>Quick Links</h3>
            <ul className="quick-links-list">
              <li><Link to="/">Company Overview</Link></li>
              <li><Link to="/about">Processing Team</Link></li>
              <li><Link to="/more">Agro Processing &amp; Exports</Link></li>
              <li><Link to="/recipes">HoReCa / Wholesale Enquiry</Link></li>
            </ul>
          </div> */}

        </div>
      </div>

      {/* ══ BENEFITS STRIP ══ */}
      <section className="contact-benefits">
        <span className="cb-label">Why Corn Bliss</span>
        <h2 className="cb-title">100% Natural. Zero Preservatives.</h2>

        <div className="benefits-strip-grid">
          {benefits.map((b) => (
            <div className="benefit-strip-card" key={b.title}>
              <span className="benefit-strip-icon">{b.icon}</span>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}

export default ContactPage;